import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#0b002b', // Maze Indigo
        },
        secondary: {
            main: '#f50057', // Pink
        },
        background: {
            default: '#eee',
        },
    },
    typography: {
        fontFamily: 'Roboto, Arial, sans-serif',
        h4: {
            fontWeight: 600,
        },
        body2: {
            fontSize: '0.9rem',
        },
    },
    components: {
        MuiList: {
            styleOverrides: {
                root: {
                    padding: 0,
                },
            },
        },
    },
});

export default theme;
